import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { ScrollPanel, ScrollPanelModule } from 'primeng/scrollpanel';
import { AppComponent } from './app.component';
import { ConsentFormOnlineComponent } from '../app/modules/consentFormOnline/consentFormOnline.component';
import { ConsentFormService } from '../app/services/consentForm.service';
import { RequestService } from '../app/services/request.service';
import { NgIf } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorDialogComponent } from './share/error-dialog/error-dialog.component';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule  } from '@angular/common';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule } from 'primeng/accordion';
import { InputNumberModule } from 'primeng/inputnumber';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { TableModule } from 'primeng/table';
import { ProgressBarModule } from 'primeng/progressbar';
import { GalleriaModule } from 'primeng/galleria';
import { ScrollTopModule } from 'primeng/scrolltop';
import { InputMaskModule } from 'primeng/inputmask';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ImageModule } from 'primeng/image';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { CardModule } from 'primeng/card';
import { SplitterModule } from 'primeng/splitter';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DataViewModule } from 'primeng/dataview';
import { ScrollerModule } from 'primeng/scroller';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SelectedItemService } from "../app/services/selectItem.service";
import { DatePipe } from '@angular/common';
import { InplaceModule } from 'primeng/inplace';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../environments/environment';

// 之前 app.routes.ts 的路由
const routes: Routes = [
  { path: '', redirectTo: 'consentFormOnline', pathMatch: 'full' },
  { path: 'consentFormOnline', component: ConsentFormOnlineComponent },
  { path: '**', redirectTo: 'consentFormOnline' }
];
const Component = [
  AppComponent,
  ErrorDialogComponent,
  ConsentFormOnlineComponent
];

const NB_MODULES = [
  MessagesModule,
  MessageModule,
  InputTextModule,
  DropdownModule,
  CommonModule,
  CalendarModule,
  AccordionModule,
  InputNumberModule,
  RippleModule,
  SidebarModule,
  TableModule,
  ButtonModule,
  ProgressBarModule,
  GalleriaModule,
  ScrollTopModule,
  ScrollPanelModule,
  InputMaskModule,
  ProgressSpinnerModule,
  FileUploadModule,
  ImageModule,
  MultiSelectModule,
  MenubarModule,
  MenuModule,
  BadgeModule,
  CardModule,
  SplitterModule,
  PanelMenuModule,
  DataViewModule,
  ScrollerModule,
  CheckboxModule,
  ToggleButtonModule,
  InplaceModule,
  RecaptchaV3Module
];

const Component_Service = [
  RequestService,
  ConsentFormService,
  SelectedItemService
];

@NgModule({
  declarations: [
    ...Component,
  ],
  imports: [
    ...NB_MODULES,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes) // 註冊路由
  ],
  providers: [
    ...Component_Service,
    MessageService,
    DatePipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}